import React from 'react';
import { usePortletTranslations } from 'js/components/system/Portlet';
import { Icon } from 'js/components/common/Icon';
import Empty from './Empty';
import TableDumb from './Table';
import style from './index.scss';

export const Title = ({ text }) => (
    <div className={style.title}>
        <Icon className={style.titleIcon} type="leaderboard" />
        <span className={style.titleText}>{text}</span>
    </div>
);

export const Table = ({ competitorsTable = [] }) => competitorsTable.length > 0
    ? <TableDumb {...{ competitorsTable }} />
    : <Empty />;

export const CompetitorsTable = ({ className = '', competitorsTable }) => {
    const t = usePortletTranslations();

    return (
        <div className={`${style.container} ${className}`}>
            <Title text={t('competitorsTable.title')} />
            <Table {...{ competitorsTable }} />
        </div>
    );
};

export default (props) => {
    const { displayTable = true } = props;

    return displayTable ? <CompetitorsTable {...props} /> : null;
};
